import { render, staticRenderFns } from "./TwoFactorConfig.vue?vue&type=template&id=3c1e4a56&scoped=true"
import script from "./TwoFactorConfig.vue?vue&type=script&lang=js"
export * from "./TwoFactorConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c1e4a56",
  null
  
)

export default component.exports